import { Button, Grid, Stack, TextField } from "@mui/material";
import "./forgot-password.scss";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowBack } from "@mui/icons-material";
import toaster from "../../../../utility/toaster/toaster";
import { postRequest } from "../../../../services/api/axios_api_Request";
import Loader from "../../../components/loader/Loader";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [isEmailSent, setIsEmailSent] = useState(false);
  const [isError, setIsError] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    toaster("info", "Please wait");
    try {
      // below api will check db if email exists, if it exists then will send reset link to that email
      const res = await postRequest("/public/forgot-password", { email: email });
      if (res.status == 200) {
        toaster("success", "Email sent successfully.");
        setIsEmailSent(true);
        setTimeout(() => {
          navigate("/login");
        }, 1500);
      } else {
        setIsError(true);
      }
    } catch (error) {
      toaster("error", error);
    }
  };

  const handleEmailOnChange = (event) => { 
    setIsError(false)
    setEmail(event.target.value)
   }


  return (
    <>
      <Grid className="forgotPassword-main-container">
        <Grid className="name-logo">
          <h1 className="heading-name-1">
            PACE<span className="heading-name-2">APPS</span>
          </h1>
        </Grid>
        {isEmailSent ? (
          <>
            <Loader></Loader>
          </>
        ) : (
          <>
            <Grid className="forgotPassword-form-container">
              <Grid className="forgotPassword-form-wrapper">
                <form onSubmit={handleSubmit}>
                  <Stack spacing={1}>
                    <Grid className="form-heading">
                      <h2>Forgot Password?</h2>
                    </Grid>
                    <Grid className="form-field">
                      {/* <p>
                        Enter the email address associated with your account and we'll send you a link to reset your
                        password.
                      </p> */}
                      <label className="form-label" htmlFor="email-form-control1">
                        Email:
                      </label>
                      <TextField
                        required
                        error={isError}
                        helperText={isError ? "User email doesn't exist. Enter valid email." : null}
                        name="email"
                        id="email-form-control121"
                        placeholder="Enter Email"
                        onChange={ (e) => handleEmailOnChange(e) }
                      />
                    </Grid>

                    <Grid className="form-button">
                      <Button type="submit" variant="contained">
                        Reset password
                      </Button>
                      <span className="arrowback-forgot-page" onClick={() => navigate("/login")}>
                        <ArrowBack />
                        Back to login
                      </span>
                    </Grid>
                  </Stack>
                </form>
              </Grid>
            </Grid>
          </>
        )}
      </Grid>
    </>
  );
}
